<template>
  <section id="nfse" class="section-shaped bg-secondary py-5 my-0">
    <div class="row row-grid justify-content-center mb-5">
      <h1 class="text-dark px-3 text-center">Nota Fiscal de Serviços Eletrônica</h1>
    </div>
    <div class="container">
      <div class="row row-grid align-items-center">
        <div class="col-md-12 col-lg-8 col-sm-12">
          <div class="pr-md-5">
            <h5>Obrigatoriedade da Nota Fiscal Eletrônica!</h5>
            <p class="text-justify">De acordo com o Governo Federal, todos os municípios do país deverão disponibilizar
              sistema para a emissão de Nota Fiscal de Serviços Eletrônica. No Portal Janela Única, o prestador de serviços
              que estiver credenciado junto à prefeitura poderá emitir fácil e rapidamente sua NFS-e. Dentre os vários
              benefícios para a prefeitura na utilização do portal estão: maior controle sobre as operações de prestação
              de serviço, eliminação de fraudes, controle de pagamento do ISS e redução de custos.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-12 col-sm-12 offset-sm-2 offset-lg-0 offset-md-3">
          <img alt="Nota Fiscal de Serviço Eletrônica" style="width: 25rem;" src="img/nfse.png" class="img-fluid floating">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'SectionNfse',
    data(){
      return {
        servicos: [
          {
            "nome":"Funcionamento Totalmente Via Internet",
            "descricao":"O Janela Única é um portal on-line destinado à Emissão da Nota Fiscal de Serviços Eletrônica e ao controle de arrecadação de todas as receitas municipais, tais como: IPTU, ISS QN, Vigilância Sanitária, ITBI, Aluguel de Próprios Municipal, Taxa e Tarifas Diversas, Certidões, Auditorias, etc.",
            "icone":"ni ni-world-2"
          },
          {
            "nome":"Rígido Controle de Acesso",
            "descricao":"Há um rígido controle de acesso e permissões para o manuseio do sistema. Para cada operador são configuradas as respectivas permissões e restrições. Além disso, todas as movimentações cadastrais realizadas sãp armazenadas e, um histórico.",
            "icone":"ni ni-badge"
          },
          {
            "nome":"Telas Padronizadas, Fácil Utilização",
            "descricao":"O sistema possui telas padrinizadas contendo títulos e figuras intuitivas que facilitam sua utilização. Para o seu manuseio são necessários apenas os conhecimentos básicos de informatica e das tarefas corriqueiras do Departamenteo de Tributos.",
            "icone":"ni ni-tie-bow"
          },
          {
            "nome":"Integração Cadastral",
            "descricao":"Cada contribuinte tem cadastro único no sistema, tornando possível e rapido a exibição, por exemplo, de um unico extrato com pagamentos e debitos, englogando todas as receitas e inscrições que possam ter relação com o respectivo contribuinte.",
            "icone":"ni ni-archive-2"
          },
          {
            "nome":"Estatísticas em Gráficos e Relatórios",
            "descricao":"São disponibilizados várias gráficos e relatórios referentes aos cadastros, aos lançamentos de tributos e a arrecadação em todos os períodos. Todos os lançamentos devedores são apresentados com as devidas correções monetárias, multas e juros, em conformidade com a legislação tributária municipal.",
            "icone":"ni ni-chart-bar-32"
          },
          {
            "nome":" Autosserviços para a Comunidade",
            "descricao":"Através do Portal Janela Única, as prefeituras poderão disponibilizar autoserviços para a comunidade, tais como: consulta de autenticidade de documentos, certidões negativas, emissão de segunda via de DAMs, etc.",
            "icone":"ni ni-spaceship"
          }
        ]
      }
    }
  };
</script>
